// extracted by mini-css-extract-plugin
export default {"tableHeader":"styles_tableHeader__16V-k","tableBody":"styles_tableBody__3pHA3"};